import { User, UserOrga } from "../../user/types/user.types"
import { userAuthTypes } from "./auth.types"

export interface IAuthData {
    token?: string | null,
    user?: User
    userOrga?: UserOrga

}


export interface IStateAuthReducer {
    authData?: IAuthData | null,
    isLoading: boolean | null,
    lastOrganizationIdLogged?: string | null

}

const INITIAL_STATE : IStateAuthReducer = {
    authData: null,
    isLoading: false,
    lastOrganizationIdLogged: undefined
}

/* ============= REDUCER ============== */
export const authReducer = (state = INITIAL_STATE, action: any) :  IStateAuthReducer => {
    switch (action.type) {
        case  userAuthTypes.IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
        case userAuthTypes.SET_AUTH_DATA:
            return {
                ...state,
                authData: action.payload
            }
        
        case userAuthTypes.SET_LAST_ORGANIZATION_ID_LOGGED:
            return {
                ...state,
                lastOrganizationIdLogged: action.payload
            }
        default:
            return state
    }
}

export default authReducer

